import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc';
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderBottomColor: '#bff0fd',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
    fontStyle: 'bold',
  },
  description: {
    width: '60%',
    textAlign: 'left',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  qty: {
    width: '10%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: 'right',
    paddingRight: 8,
  },
  rate: {
    width: '15%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: 'right',
    paddingRight: 8,
  },
  amount: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 8,
  },
});

export const InvoiceTableRow = ({ items }) => {
  const rows = items.map(item => (
    <View style={styles.row} key={item?.invoice_item_id}>
      <Text style={styles.description}>{item?.invoice_item_name}</Text>
      <Text style={styles.qty}>{item.invoice_item_qty}</Text>
      <Text style={styles.rate}>
        $
        {(item?.invoice_item_amount / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      </Text>
      <Text style={styles.amount}>
        $
        {((item.invoice_item_qty * item?.invoice_item_amount) / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      </Text>
    </View>
  ));
  return <>{rows}</>;
};
